import { useState, useEffect, useRef } from "react";
import {
  Autocomplete,
  Box,
  Button,
  TextField,
  Menu,
  MenuItem,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CommentsGrid from "./CommentsGrid";
import CommentDetail from "./CommentDetail";
import { UseComment } from "./UseComment";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate, useLocation } from "react-router-dom";

export default function Comments(props) {
  let navigate = useNavigate();
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [getComment, setGetComment] = useState(1);
  const [commentState, setCommentState] = useState("newComment");
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [anchorEl, setAnchorEl] = useState(null);
  const openD = Boolean(anchorEl);
  const [search, setSearch] = useState("");
  const [searchColumn, setSearchColumn] = useState("Mobile");
  const [searchName, setSearchName] = useState("جستجو براساس موبایل");
  const [detailCom, setDetailCom] = useState();
  const [msScrollComment, setMsScrollComment] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { GetCommentByID } = UseComment();
  const [searchModel, setSearchModel] = useState({
    Mobile: "",
    ProductID: "",
    ArticleID: "",
    CommentID: "",
  });
  const [pageState, setPageState] = useState(1);

  useEffect(() => {
    if (location && location.hash) {
      setSearch(location.hash.replace("#", ""));
      setGetComment(3);
      setCommentState("allComments");
      setSearchName("جستجو براساس موبایل");
      setSearchColumn("Mobile");
      setAnchorEl(null);
      setSearchModel({
        Mobile: location.hash.replace("#", ""),
        ProductID: "",
        ArticleID: "",
        CommentID: "",
      });
      return navigate(`/comments`);
    }
  }, [location]);

  useEffect(() => {
    setDetailCom();
  }, [commentState]);

  function getBYID(CommentID) {
    GetCommentByID(CommentID, (callBack) => {
      setDetailCom(callBack);
      const element = document.getElementById("scrollTo");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 1000);
    });
  }

  return (
    <Detail
      breadChilds={{
        title: "ارتباط با مشتری",
        childs: [{ name: msActiveMenu.pageTitle, url: "/comments" }],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            mb: 3,
          }}
        >
          <Button
            sx={{ width: "150px" }}
            variant={commentState == "newComment" ? "contained" : "outlined"}
            startIcon={commentState == "newComment" && <CheckIcon />}
            onClick={() => {
              setSearchModel({
                Mobile: "",
                ProductID: "",
                ArticleID: "",
                CommentID: "",
              });
              setSearch("");
              setGetComment(1);
              setDetailCom();
              setCommentState("newComment");
            }}
          >
            کامنت های جدید
          </Button>
          <Button
            sx={{ width: "150px", mx: 2 }}
            startIcon={commentState == "myComment" && <CheckIcon />}
            variant={commentState == "myComment" ? "contained" : "outlined"}
            onClick={() => {
              setSearchModel({
                Mobile: "",
                ProductID: "",
                ArticleID: "",
                CommentID: "",
              });
              setSearch("");
              setGetComment(2);
              setDetailCom();
              setCommentState("myComment");
            }}
          >
            کامنت های من
          </Button>
          <Button
            sx={{
              width: "150px",
            }}
            startIcon={commentState == "allComments" && <CheckIcon />}
            variant={commentState == "allComments" ? "contained" : "outlined"}
            onClick={() => {
              setDetailCom();
              setGetComment(3);
              setCommentState("allComments");
            }}
          >
            کامنت ها
          </Button>
          {commentState == "allComments" && (
            <Box>
              <TextField
                helperText="* فیلد را کامل کنید"
                sx={{
                  ml: 3,
                  "& .MuiInputLabel-root": {
                    fontSize: "0.9rem !important",
                  },
                  "& .MuiFormHelperText-root": {
                    color: "red",
                  },
                }}
                label={searchName}
                value={search ? search : ""}
                onChange={(evt) => {
                  setAnchorEl(false);
                  if (evt.target.value == "") {
                    setSearchModel({
                      Mobile: "",
                      ProductID: "",
                      ArticleID: "",
                      CommentID: "",
                    });
                    setSearch("");
                  }
                  setSearch(evt.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setAnchorEl(false);
                    setDetailCom();
                    if (searchColumn == "Mobile") {
                      setSearchModel({
                        Mobile: search,
                        ProductID: "",
                        ArticleID: "",
                        CommentID: "",
                      });
                    } else if (searchColumn == "ProductID") {
                      setSearchModel({
                        Mobile: "",
                        ProductID: search,
                        ArticleID: "",
                        CommentID: "",
                      });
                    } else if (searchColumn == "ArticleID") {
                      setSearchModel({
                        Mobile: "",
                        ProductID: "",
                        ArticleID: search,
                        CommentID: "",
                      });
                    } else if (searchColumn == "CommentID") {
                      setSearchModel({
                        Mobile: "",
                        ProductID: "",
                        ArticleID: "",
                        CommentID: search,
                      });
                    }
                  }
                }}
                fullWidth
                InputProps={{
                  autoComplete: "off",
                  inputProps: {
                    min: 1,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        id="basic-button"
                        aria-controls={openD ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={openD ? "true" : undefined}
                        onClick={(event) => setAnchorEl(event.currentTarget)}
                        edge="end"
                      >
                        <MoreVertIcon
                          fontSize="small"
                          sx={{ color: "primary.main" }}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openD}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                sx={{
                  "&.MuiMenu-list": {
                    width: "200px",
                  },
                }}
              >
                <MenuItem
                  sx={{ px: 5 }}
                  onClick={() => {
                    setSearchName("جستجو براساس موبایل");
                    setSearchColumn("Mobile");
                    setAnchorEl(null);
                  }}
                >
                  موبایل
                </MenuItem>
                <MenuItem
                  sx={{ px: 5 }}
                  onClick={() => {
                    setSearchName("جستجو براساس کد محصول");
                    setSearchColumn("ProductID");
                    setAnchorEl(null);
                  }}
                >
                  کد محصول
                </MenuItem>
                <MenuItem
                  sx={{ px: 5 }}
                  onClick={() => {
                    setSearchName("جستجو براساس کد مقاله");
                    setSearchColumn("ArticleID");
                    setAnchorEl(null);
                  }}
                >
                  کد مقاله
                </MenuItem>
                <MenuItem
                  sx={{ px: 5 }}
                  onClick={() => {
                    setSearchName("جستجو براساس کد کامنت");
                    setSearchColumn("CommentID");
                    setAnchorEl(null);
                  }}
                >
                  کد کامنت
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Box>

        <Box>
          <CommentsGrid
            search={search}
            setSearchModel={setSearchModel}
            setMsScrollComment={setMsScrollComment}
            searchColumn={searchColumn}
            searchName={searchName}
            searchModel={searchModel}
            getComment={getComment}
            detailCom={detailCom}
            setDetailCom={setDetailCom}
            callBYID={(commentID) => {
              setProgress(true);
              getBYID(commentID);
            }}
            refresh={refresh}
            setRefresh={setRefresh}
            setPageState={setPageState}
            pageState={pageState}
          />
        </Box>
        <Box id="scrollTo">
          {detailCom && detailCom.id ? (
            <CommentDetail
              getComment={getComment}
              setMsScrollComment={setMsScrollComment}
              commentState={commentState}
              detailCom={detailCom && detailCom}
              setDetailCom={setDetailCom}
              callBYID={(commentID) => {
                setProgress(true);
                getBYID(commentID);
              }}
              refresh={refresh}
              setRefresh={setRefresh}
              setPageState={setPageState}
              pageState={pageState}
            />
          ) : (
            ""
          )}
        </Box>
      </Box>
    </Detail>
  );
}
